import classNames from 'classnames';
import * as React from 'react';
import { TBooleanInNumber } from 'src/types/main';
import { booleanNumberReverse } from 'src/utils/helpers';
import './style.scss';

interface ISwitcherProps {
  status: TBooleanInNumber;
  className?: string;
  activeClassName?: string;
  inActiveClassName?: string;
  onChange: (status: TBooleanInNumber, cb?: () => void) => void;
  disabled?: boolean;
  error?: boolean;
  hasCallback?: boolean;
}

interface ISwitcherState {
  status: TBooleanInNumber;
}

export default class Switcher extends React.Component<ISwitcherProps, ISwitcherState> {
  activeClassName: string = this.props.activeClassName || 'bg-mainblue';
  inActiveClassName: string = this.props.inActiveClassName || 'bg-gray';

  state: ISwitcherState = {
    status: this.props.status,
  };

  public set status(status: ISwitcherProps['status']) {
    this.setState({ status });
  }

  public get buttonClassName(): string {
    const statusClassName: string = this.state.status ? ` ${this.activeClassName || ''} active` : this.inActiveClassName;
    return classNames('switcher-wrapper', statusClassName, this.props.className, { disabled: this.props.disabled, switcher_error: this.props.error });
  }

  componentDidUpdate = (props: ISwitcherProps) => {
    if (this.props.status !== props.status) this.setState({ status: this.props.status });
  };

  toggle = () => {
    if (this.props.disabled) return;

    if (this.props.hasCallback) {
      this.props.onChange(booleanNumberReverse(this.state.status), () => {
        this.setState((state) => ({ status: booleanNumberReverse(state.status) }));
      });
    } else {
      this.setState((state) => ({ status: booleanNumberReverse(state.status) }), this.onChange);
    }
  };

  onChange = () => {
    this.props.onChange(this.state.status);
  };

  public render() {
    return (
      <button className={this.buttonClassName} onClick={this.toggle}>
        <div className="switcher-circle" />
      </button>
    );
  }
}
